var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNofollow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.041 29.3631C28.041 24.192 32.233 20 37.4041 20C42.5753 20 46.7672 24.192 46.7672 29.3631C46.7672 34.5343 42.5753 38.7262 37.4041 38.7262C32.233 38.7262 28.041 34.5343 28.041 29.3631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6432 61.6668C55.4942 61.6668 60.2376 56.9234 60.2376 51.0724C60.2376 45.2214 55.4942 40.478 49.6432 40.478C43.7922 40.478 39.0488 45.2214 39.0488 51.0724C39.0488 56.9234 43.7922 61.6668 49.6432 61.6668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9338 41.3693C35.4861 41.3693 36.0385 41.3683 36.5909 41.3675L37.4449 41.3662C38.3703 41.365 38.871 42.5233 38.3449 43.285C36.817 45.4973 35.9221 48.1804 35.9221 51.0725C35.9221 54.0387 36.8635 56.7852 38.4639 59.0293C39.0093 59.7941 38.5039 60.9893 37.5645 60.9893H26.6862C23.5458 60.9893 21 58.4435 21 55.3031C21 47.6077 27.2384 41.3693 34.9338 41.3693Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8068 49.5227V53.3636H45.1932V49.5227H55.8068Z",
    fill: "#DADADA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofollow);
export default __webpack_public_path__ + "static/media/Nofollow.8b8d1848af90e78fa199b3e54f8f47b4.svg";
export { ForwardRef as ReactComponent };